import { createI18n } from 'vue-i18n'
import zh from './config/zh'
import en from './config/en'

// 注意：这里不再需要合并 Element Plus 的语言包
// 因为我们已经在 main.js 中单独配置了 Element Plus 的 locale
const messages = {
  zh: {
    ...zh
  },
  en: {
    ...en
  }
}

// 整站默认英文：所有人（含老访客）首次进入一律强制英文。
// 通过版本标记只重置一次：老访客浏览器里遗留的 'zh' 会被清掉；
// 重置之后用户再通过语言菜单手动选择的中文仍会正常保留。
const LOCALE_VER = 'en-default-1'
if (localStorage.getItem('localeVer') !== LOCALE_VER) {
  localStorage.setItem('locale', 'en')
  localStorage.setItem('localeVer', LOCALE_VER)
}

const savedLocale = localStorage.getItem('locale') === 'zh' ? 'zh' : 'en'
// 回写下 localStorage，保证全站所有读取 locale 的地方拿到的值一致
localStorage.setItem('locale', savedLocale)

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages
})

export default i18n